import { IMobileOffer } from "@nju/data-access-portal-offers";
import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";
import { IScope } from "@nju/scope";
import { Separator, SideBox } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { SidebarMobileOfferBenefits } from "../SidebarOffer/partials";
import { SidebarMobileOfferDuoTrioNumber } from "./SidebarMobileOfferDuoTrioNumber";

interface ISidebarMobileOfferProps {
  offer: IMobileOffer;
  orchestrator: IMultiOrderOrchestrator | undefined;
  isOrderSummary?: boolean;
  variant: IScope;
}

export function SidebarMobileOfferDuoTrio({
  offer,
  orchestrator,
  variant = "portal",
  isOrderSummary = false,
}: ISidebarMobileOfferProps) {
  if (!orchestrator || !orchestrator.multiOrderItems) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const isPostpaid = orchestrator.offerCategory === "MOBILE_POSTPAID";

  return (
    <SideBox
      isExpandable={true}
      isExpanded={false}
      testId="mobile-offer-box"
      title={isPostpaid ? "nju abonament" : "nju subskrypcja"}
      underline="none"
      variant="h4"
    >
      {({ isExpanded }) => {
        return isExpanded ? (
          <>
            <Separator size="m" thickness="medium" tone="accent" />
            <div className="absolute text-size-16 font-bold text-white bg-daintree py-[9.5px] px-[8.5px] rounded-b-[8px] right-3 mt-[-17px] from-tablet:right-6 from-tablet:mt-[-21px]">
              <span>5G</span>
            </div>
            <SidebarMobileOfferBenefits
              benefits={offer.shortFeatures}
              bonusFeatures={offer.bonusFeatures}
              bundleDiscount={offer.ftthBundleDiscount || offer.bundleDiscount}
              discountFeatures={offer.discountFeatures}
              extras={offer.extraShortFeatures}
              installationPrice={formatPrice(offer.totalOneTimePrice)}
              isFreeFromActivationFee={offer.isFreeFromActivationFee}
              orchestrator={orchestrator}
              paymentFeatures={offer.paymentFeatures}
              variant={variant}
            />
            <Separator size="s" tone="invisible" />
            <SidebarMobileOfferDuoTrioNumber
              currentOnboardingMember={orchestrator?.currentMultiOrderItem}
              discountFeatures={offer.discountFeatures}
              isOrderSummary={isOrderSummary}
              isPostpaid={isPostpaid}
              orderItems={orchestrator.multiOrderItems}
            />
          </>
        ) : (
          <>
            <Separator size="m" thickness="medium" tone="accent" />
            <SidebarMobileOfferDuoTrioNumber
              currentOnboardingMember={orchestrator?.currentMultiOrderItem}
              discountFeatures={offer.discountFeatures}
              isOrderSummary={isOrderSummary}
              isPostpaid={isPostpaid}
              orderItems={orchestrator.multiOrderItems}
            />
          </>
        );
      }}
    </SideBox>
  );
}
